// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"41827143","787":"f3f68feb"}[chunkId] + ".chunk.js";
};